import axios from 'axios';
import useToken from 'modules/auth/atoms/use-token';
import {useQueryClient} from 'react-query';
import {errorNotification} from 'shared/services/notification';

export const baseURL = 'https://api.uaudelivery.com.br';
export const socketUrl = 'https://websocket.uaudelivery.com.br';

export default () => {
  const {token, setToken} = useToken();
  const queryClient = useQueryClient();

  const createAxiosInstance = () =>
    axios.create({
      baseURL,
      headers: {
        'origin-platform': 'partners_desktop',
      },
    });

  const api = createAxiosInstance();

  api.interceptors.request.use(async (req) => {
    if (token && !(req as any).headers.Authorization)
      req.headers!.Authorization = `Bearer ${token}`;

    return req;
  });

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;

      if (
        error?.response?.status === 401 &&
        !originalRequest?.__isRetryRequest &&
        error?.config.url !== '/auth/login'
      ) {
        originalRequest.retry = true;

        queryClient.clear();
        localStorage.clear();
        window.location.reload();
        setToken(null);

        errorNotification({
          title: 'Sua sessão expirou',
          message: 'Faça o login e tente novamente',
        });
        return;
      }
      return Promise.reject(error);
    },
  );

  return api;
};
